import { useState, useEffect } from 'react';
import { useTranslation, FAIcon, IconStyle, Theme, useSession } from '@nextgen-web-framework/all';
import { SwitchAccountButton } from '@commerce-identity-webcomponents/ui';
import { cleanUpCartLS } from '@commerce-cart-webcomponents/sdk';
import { UserInfoPropsTypes, UserInfoSourceType } from './types/propsTypes';
import styles from './UserInfo.module.scss';

const UserInfo = (props: UserInfoPropsTypes) => {
  const t = useTranslation();
  const { session } = useSession();
  const { isABO, isMember, isRegistered } = useSession();
  const [hasMounted, setHasMounted] = useState(false);
  const handleSwitchAccount = () => {
    cleanUpCartLS();
    location.reload();
  };
  useEffect(() => {
    setHasMounted(true);
  }, []);
  let userInfoLabelKey: string | null = null;

  if (hasMounted) {
    if (isABO()) {
      userInfoLabelKey = 'web.userInfo.amwayBusinessOwner';
    } else if (isMember()) {
      userInfoLabelKey = 'web.userInfo.amwayMember';
    } else if (isRegistered()) {
      userInfoLabelKey = 'web.userInfo.amwayCustomer';
    }
  }
  return (
    <div className={`${styles['user-info-container']}`} data-testid="user-info-test-id">
      <div className={`${styles['user-info-account']}`}>
        <div className={`${styles['user-info-account-avatar']}`}>
          <FAIcon iconName={'circle-user'} theme={Theme.PURPLE} iconStyle={IconStyle.SOLID} />
        </div>
        {session?.multiAccount && (
          <div data-testid="switch-account-testid">
            <SwitchAccountButton onCallBack={handleSwitchAccount} />
          </div>
        )}
      </div>
      <div className={`${styles['user-info-detail']}`}>
        <span className={`${styles['user-info-title']}`}>
          {props.customGreeting ?? `${t('web.userInfo.greeting')} ${props.userName}`}
        </span>
        {userInfoLabelKey ? <div className={`${styles['user-info-account-info']}`}>{t(userInfoLabelKey)}</div> : null}
        <div className={`${styles['user-info-detail-others']}`}>
          <div className={`${styles['user-info-detail-info']}`}>
            <span className={styles['user-info-detail-label']}>{t('web.userInfo.accountNo')}</span>
            <span>{props.accountNo}</span>
          </div>
          <div className={`${styles['user-info-detail-bar']}`} />
          <div className={`${styles['user-info-detail-info']}`}>
            <span className={styles['user-info-detail-label']}>{t('web.userInfo.expiryDate')}</span>
            <span>{props.expiryDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
export { UserInfoSourceType };
